import { useEffect } from 'react';
import { config } from '../config/config';

const BackendHealthCheck = () => {
  useEffect(() => {
    fetch(`${config.API_URL}/health`)
      .catch((err) => console.warn('Backend health check failed:', err));

    const interval = setInterval(() => {
      fetch(`${config.API_URL}/health`)
        .catch((err) => console.warn('Backend health check failed:', err));
    }, 4 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  return null;
};

export default BackendHealthCheck;
